import {
  FilterMode,
  ICheckboxGroupConfig,
  ICheckboxGroupValue,
  IDropdownCheckboxValueItemConfig,
  IOption,
} from "component-library";

import { IMakeSuggestionsDropDownChecboxFilterTranslation } from "models/suggestion";

import { IFacetGroup } from "shared/models/facet";

import { IRangeFilterModel, IRangeTranslation } from "./RangeFilter";

export interface IFilterConfigItemOptions
  extends ICheckboxGroupConfig<IDropdownCheckboxValueItemConfig> {}

export enum FilterType {
  Gender = "gender",
  Agents = "agents",
  PlayingAge = "playingAge",
  WhichCV = "whichCV",
  TextFilter = "textFilter",
  PageNumber = "pageNumber",
  PageSize = "pageSize",
  Appearance = "appearance",
  Locations = "locationId",
  HeritageAndEthnicity = "heritageAndEthnicity",
  EthnicBackground = "ethnicBackground",
  HeritageAndEthnicityFilterMode = "heritageAndEthnicityFilterMode",
  HeritageAndEthnicityInfo = "heritageAndEthnicityInfo",
}

export enum WhichCVFilterValues {
  Nudges = "Nudges",
  SelfSuggestions = "SelfSuggestions",
  Suggestions = "Suggestions",
}

export enum WhichCVType {
  AllProfiles = "allProfiles",
  CurrentSuggestions = "currentSuggestions",
  Nudges = "nudges",
  SelfSuggestions = "selfSuggestions",
}

export interface IFilterModel {
  [FilterType.Gender]: ICheckboxGroupValue;
  [FilterType.Agents]: ICheckboxGroupValue;
  [FilterType.PlayingAge]: IRangeFilterModel;
  [FilterType.PageNumber]: number;
  [FilterType.WhichCV]: WhichCVType;
  [FilterType.TextFilter]: string | undefined;
  [FilterType.HeritageAndEthnicityInfo]?: string;
  [FilterType.PageNumber]: number;
  [FilterType.PageSize]: number;
  [FilterType.Appearance]: ICheckboxGroupValue;
  [FilterType.Locations]: IOption<string>[];
  [FilterType.EthnicBackground]: ICheckboxGroupValue;
  [FilterType.HeritageAndEthnicity]: ICheckboxGroupValue;
  [FilterType.HeritageAndEthnicityFilterMode]: FilterMode;
}

export enum FilterControlType {
  CheckboxGroup = "checkboxGroup",
  DropdownCheckbox = "dropdownCheckbox",
  RangeSelectionDropdown = "RangeSelectionDropdown",
  Locations = "Locations",
  Text = "Text",
  Other = "Other",
}

export interface IFilterConfigItem {
  translations:
    | string
    | IRangeTranslation
    | IMakeSuggestionsDropDownChecboxFilterTranslation
    | Record<string, string>;
  defaultValue: any;
  filterControlType?: FilterControlType;
  drawerFilterControlType?: FilterControlType;
  facets?: IFacetGroup[];
  filterOptions: IFilterConfigItemOptions;
}

export type IFilterConfig = Record<
  keyof Pick<
    IFilterModel,
    | FilterType.Agents
    | FilterType.Gender
    | FilterType.PlayingAge
    | FilterType.Appearance
    | FilterType.Locations
    | FilterType.EthnicBackground
    | FilterType.HeritageAndEthnicity
    | FilterType.HeritageAndEthnicityFilterMode
    | FilterType.HeritageAndEthnicityInfo
  >,
  IFilterConfigItem
>;

export const whichCVToFilterMapping: Record<
  WhichCVType,
  WhichCVFilterValues | undefined
> = {
  [WhichCVType.AllProfiles]: undefined,
  [WhichCVType.Nudges]: WhichCVFilterValues.Nudges,
  [WhichCVType.SelfSuggestions]: WhichCVFilterValues.SelfSuggestions,
  [WhichCVType.CurrentSuggestions]: WhichCVFilterValues.Suggestions,
};
